var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"loginimage-w",attrs:{"src":require("@/assets/images/partner/kewalcare.png"),"alt":"image"}})])
}]

export { render, staticRenderFns }